import ContractHistory from './ContractHistory';

export default ContractHistory;
